<template>
  <div>
    <a-modal
      :centered="true"
      :width="587"
      v-model="showModal"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="hide"
    >
      <p class="heading">Filter Resources</p>
      <div
        v-for="(filter_item, index) in filter_item_list"
        :key="index"
        class="filter-item"
      >
        <a-radio-group v-model:value="answer">
          <a-radio :value="itemValue[index]" :disabled="disable_filter[index]">
            <font-awesome-icon
              size="lg"
              class="mr-2"
              :style="{ color: disable_filter[index]? '#babbbe':getPrimaryColor(), width: '30px' }"
              :icon="['fas', itemIcon[index]]"
            />{{ filter_item }}</a-radio
          >
        </a-radio-group>
      </div>
      <div class="footer">
        <button class="cancel" @click="hide">Cancel</button>
        <button
          class="apply"
          :style="{ background: getPrimaryColor() }"
          @click="apply"
        >
          Apply Filters
        </button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Checkbox } from "ant-design-vue";
import {
  faBookOpen,
  faThumbsUp,
  faPollH,
  faVideo,
  faPenSquare,
  faPortrait
} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faBookOpen, faThumbsUp, faPollH, faVideo, faPenSquare, faPortrait);

export default {
  name: "ResourceFilterModal",

  props: {
    handleAnswer: Function,
    disable_filter: Array,
    answer: String
  },

  data() {
    return {
      showModal: false,
      filter_item_list: [
        "Articles",
        "Polls",
        "Quizzes",
        "Trivia",
        "Slideshows",
        "Videos",
        "Physician Blogs",
        // "Ask A Doctor",
        // "Recommended"
      ],
      itemIcon: [
        "book-open",
        "poll",
        "question-circle",
        "poll-h",
        "portrait",
        "video",
        "pen-square",
        // "question-circle",
        // "thumbs-up"
      ],
      itemValue: [
        "articles",
        "poll",
        "quiz",
        "trivia",
        "slideshows",
        "videos",
        "physicianBlogs",
        // "askADoctor",
        // "recommended"
      ]
    };
  },

  components: {
    "a-checkbox": Checkbox
  },

  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    apply() {
      this.hide();
      this.handleAnswer(this.answer);
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  font-family: "Lato";
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
  padding: 24px;
}

.footer {
  padding: 24px;
  display: flex;
  justify-content: flex-end;
}

.cancel {
  padding: 12px 24px;
  background: #e2e8f0;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  color: #47556e;
  margin-right: 10px;
}

.apply {
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
}

.filter-item {
  height: 60px;
  background: #f8fafd;
  border-radius: 6px;
  border: none;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #1e2945;
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ResourceFilterModal.vue